import React from "react";

const VersionUpdates: React.FC = () => {
	const updates = [
		{
			date: "August 25, 2026",
			items: [
				"Only allow departments with PO Approval routing in header. Line level departments will still show all departments.",
				"Bug fix on department dropdown not showing all departments on line when header department is selected.",
				'Added "Clear" buttons for header and line department dropdowns for easier reset',
			],
		},
		{
			date: "August 24, 2026",
			items: ["Bug fix on line item edit/add/remove when editing existing PO"],
		},
		{
			date: "August 21, 2026",
			items: [
				"Allow up to 10 file attachments for PO creation/edit",
				"Add ability to view approval route in PO details page",
				"Create new 'Search All POs' page to search for POs by Vendor, or Submitter (email)",
				"FAQ updates",
			],
		},
		{
			date: "July 29, 2026",
			items: [
				"Allow updating of Vendor on PO Edit",
				"Redirect to PO Details page after PO creation or edit",
			],
		},
		{
			date: "July 10, 2026",
			items: [
				"Bug fix for PO Approver validation",
				"Bug fix for Approve button spinner issue",
			],
		},
		{
			date: "June 24, 2026",
			items: [
				"When 'POs requiring my approval' toggle is enabled, the date filter is automatically set to 'All' and legacy POs are shown.",
			],
		},
		{
			date: "May 15, 2026",
			items: [
				"New FAQ section on Home page with answers to common questions.",
				"New feature to receive Purchase Orders with receival date and optional memo. Partial receivals are also supported where you can select which line items to receive and which to leave pending for future receival.",
				"Ability to approve/reject POs if you are the next approver with optional rejection reason for rejected POs.",
			],
		},
		{
			date: "May 12, 2026",
			items: [
				"Copy PO feature",
				"Show Rejection Reason when hovering over status in PO List page as well as in PO details page when editing",
				"Ability to receive PO after approval with receival date and optional memo.",
			],
		},
		{
			date: "May 7, 2026",
			items: [
				"Show last 5 POs for vendor when clicking on vendor name in PO List page",
				"Display address of Vendor in dropdown list on PO Creation form to help differentiate between vendors with similar names",
			],
		},
		{
			date: "May 6, 2026",
			items: [
				"Increase max line items for PO creation from 5 to 22",
				"Include Deferred Expense accounts on account dropdown in PO creation form",
				'Fix "sticky dropdown" issue where multiple dropdowns could be open at the same time',
				"Changed auth from session storage to local storage to fix login persistence issues",
				"Added URL parameter to PO List page to filter by PO ID",
				"Reset PO List filters when clicking on PO List link in navigation bar",
			],
		},
		{
			date: "May 4, 2026",
			items: [
				"Filters for PO List page (by Vendor, PO Number, Date, and Status)",
				"Show legacy POs created directly in NetSuite",
				"Fixed: Show Body Memo in PO details page. Previously only showed Line Memo.",
				"Fixed: Show Location and Due Date/Receive By date in PO details page",
			],
		},
		{
			date: "May 1, 2026",
			items: [
				"Allow editing of PO after it was rejected",
				"Download PO as PDF after approval",
			],
		},
		{
			date: "April 21, 2026",
			items: [
				"Expand/Collapse PO expense line items in PO List page",
				"Allow editing of PO until it is approved",
			],
		},
		{
			date: "April 20, 2026",
			items: [
				"Ability to edit rejected purchase orders and re-submit",
				"PO authorization check",
				"Copy expense line",
			],
		},
		{
			date: "April 16, 2026",
			items: ["Puff Relay launch"],
		},
	];

	return (
		<div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-4xl mx-auto">
				{/* Page Header */}
				<div className="mb-8">
					<h1 className="text-4xl font-bold text-gray-900 mb-2">
						Version Updates
					</h1>
					<p className="text-gray-600">
						Track the latest improvements and features
					</p>
				</div>

				{/* Content Card */}
				<div className="bg-white rounded-lg shadow-md p-8">
					<div className="overflow-x-auto">
						<table className="min-w-full border-collapse">
							<thead>
								<tr className="bg-gray-100 border-b-2 border-gray-300">
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 w-40">
										Date
									</th>
									<th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">
										Updates
									</th>
								</tr>
							</thead>
							<tbody>
								{updates.map((update, index) => (
									<tr
										key={index}
										className="border-b border-gray-200 hover:bg-gray-50 transition"
									>
										<td className="px-6 py-4 text-sm font-semibold text-gray-900 align-top">
											{update.date}
										</td>
										<td className="px-6 py-4 text-sm text-gray-700">
											<ul className="list-disc list-inside space-y-2">
												{update.items.map((item, itemIndex) => (
													<li key={itemIndex}>{item}</li>
												))}
											</ul>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Back to Home */}
					<div className="mt-6">
						<a
							href="/"
							className="inline-block px-6 py-2 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition"
						>
							Back to Home
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export { VersionUpdates };
